import React from 'react';


const Empty = () => {
    return(
        <div className="empty">
            ERROR
        </div>
    )
}

export default Empty;